export enum AlarmType {
    Hourly = 'Hourly',
    Return = 'Return',
    Daily = 'Daily',
    EnergyWeighted = 'EnergyWeighted'
}